export enum TipologicaSelectEnum {
  PROVINCE = 'province',
  COMUNI = 'comuni'
}
